import React, {useContext} from 'react';
import {useSelector} from 'react-redux';
import UserContext from "../../UserContext"
import ArgoButtonHook from "./ArgoButtonHook";


export default function ArgoToolbarHook(props) {

    const theme = useContext(UserContext)

    // QDII-2139: block SAVE while template saves/creates are still in flight
    const saveInFlightCount = useSelector(state => (state.saveInFlight && state.saveInFlight.count) || 0);
    const isSaving = (props.isSaving ?? false) || saveInFlightCount > 0;

    const fileName = props.fileName ?? "NoFileName";
    const fieldName = props.fieldName ?? "NoFieldName";

    const uniqueIdentifier = fileName + "-ArgoToolbarHook-" + fieldName;
    const uniqueIdentifierErrorText = uniqueIdentifier + "error-message";

    const buttonTitles = props.buttonTitles ?? ["SAVE","CANCEL"];

    const toolbarErrorText = (props.toolbarErrorText === undefined || props.toolbarErrorText.trim() === "") ? "" : "Errors on page: " + props.toolbarErrorText;

    const icon = props.icon ?? undefined

    const isValidating = props.isValidating ?? false;

    const leftButtonDisabled = props.leftButtonDisabled ?? ((toolbarErrorText !== "") || isValidating || isSaving);

    const onClick = props.onClick ?? function () {};

    const width = (parseInt(props.width) - 2).toString() + "%" ?? "100%";

    const templateEditor = props.templateEditor; // Added to prevent questionnaire cursor jump. Removed from questionnaireContainer mapStateToProps
    const options = props.options; // Added to prevent questionnaire cursor jump. Removed from questionnaireContainer mapStateToProps


    const handleLeftButtonOnClick = (event) => {
        onClick(event, fieldName, buttonTitles[0], templateEditor, options);
    };

    const handleRightButtonOnClick = (event) => {
        onClick(event, fieldName, buttonTitles[1], templateEditor, options);
    };


    return (
        <div
            id={uniqueIdentifier}
            style={{
                backgroundColor: theme.toolbar.backgroundColor,
                width,
                height: "50px",
                fontFamily: theme.fontFamily,
                position: "fixed",
                zIndex: 1000,
                display: "flex",                  // use flexbox
                alignItems: "center",             // vertically center buttons + text
                justifyContent: "space-between",  // space left and right apart
                padding: "0 20px",                // horizontal padding
                gap: 1                       // optional gap between elements
            }}
        >
            <ArgoButtonHook
                fileName="ArgoToolBarHook"
                fieldName="button-left"
                label={buttonTitles[0]}
                disabled={leftButtonDisabled}
                toolbar={true}
                onClick={handleLeftButtonOnClick}
                width="100px"
            />
            {leftButtonDisabled ?
                <div
                    id={uniqueIdentifierErrorText}
                    style={{
                        display: "flex",
                        flex: "1 1 auto",               // allow grow/shrink
                        color: theme.palette.errorColor,
                        fontSize: "12px",
                        textAlign: "left",            // center between buttons
                        padding: "0 10px",              // small padding
                        wordWrap: "break-word",         // allow wrapping mid-word
                        overflowWrap: "anywhere",       // wrap long text
                        whiteSpace: "normal",
                        alignItems: "center",
                        gap: "2px"
                    }}
                >
                    {toolbarErrorText}
                    {toolbarErrorText.includes("Key Metric Classification Mismatch!") && icon}
                </div> : ""
            }
            {(buttonTitles.length > 1) ?
                <ArgoButtonHook
                    fileName="ArgoToolBarHook"
                    fieldName="button-right"
                    variant="text"
                    label={buttonTitles[1]}
                    toolbar={true}
                    onClick={handleRightButtonOnClick}
                    width="100px"
                /> : ""
            }
        </div>
    );
}
